module.exports = __webpack_public_path__ + "img/fondo-banner-principal.eba6725d.png";